<script>
import appConfig from '@src/app.config.json'
import Axios from '@plugin/axios'
import Layout from '@layouts/main.vue'
import Hero from '@components/ui/hero-jumbotron.vue'
import DirectoryCard from '@components/ui/cards/directory-card.vue'
import Pagination from '@components/ui/basic-pagination.vue'

export default {
  page() {
    return {
      title: this.showModal ? this.pageTitle : this.pageParentTitle,
      meta: this.showModal ? this.pageMeta : this.pageParentMeta,
    }
  },
  components: {
    Layout,
    Hero,
    DirectoryCard,
    Pagination,
  },
  filters: {
    plainText: function(HTML) {
      var input = HTML
      return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
        .replace(/<[^>]+?>/g, '')
        .replace(/\s+/g, ' ')
        .replace(/ /g, ' ')
        .replace(/>/g, ' ')
    },
  },
  data() {
    return {
      directories: [],
      modalData: [],
      page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
      limit: 12,
      totalData: 0,
      totalPages: 0,
      activeOrder: 'A - Z',
      showModal: false,
      currentUrl: window.location.origin + window.location.pathname,
      filterData: {
        kategori: 'Semua',
        category: 'All',
        jenis_institusi: 'Semua',
        institution_type: 'All',
        sub_industri: 'Semua',
        sub_industry: 'All',
      },
      order: 'asc',
      orderBy: 'title',
      filterValDataID: {
        kategori: '',
        jenis_institusi: '',
        sub_industri: '',
      },
      filterValDataEN: {
        category: '',
        institution_type: '',
        sub_industry: '',
      },
      filters: {
        categories: {},
        institution_type: {},
        sub_industry: {},
      },
      showSubFilter: false,
      params: [],
      generatedParams: '',
      choosenCategoryParam: '',
      /** skeleton and loading state */
      loadOpacity: false,
      isLoading: true,
      isModalLoading: false,
      pageName: 'default',
      /** language switcher global */
      lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id',
      /** for SEO, meta and hero */
      featuredImage: '',
      pageTitle: 'Loading...',
      pageDescription: '',
      pageMeta: [],
      pageParentTitle: 'Loading...',
      pageParentDescription: '',
      pageParentMeta: [],
      nullData: false,
      firstLoad: false,
    }
  },
  watch: {
    showModal() {
      if (this.showModal === false) {
        this.addHashToLocation('/directories')
      }
    },
    page: function() {
      this.loadOpacity = true
      if (this.page >= 1) {
        // console.log(this.page)
        this.params.page = this.page
        return new Promise((resolve, reject) => {
          resolve(this.getDirectories(this.params))
        })
      }
    },
  },
  mounted() {
    if (this.$route.query.klaster_slug !== undefined) {
      const query = this.$route.query
      // console.log(query)
      this.filters.sub_industry = {}
      this.getDirectories({}, false, query)
      this.generatedParams = this.generateParams({}, query, 'taxonomy', false)
      this.params = query
      if (this.lang === 'en') {
        this.filterData.category = query.catName ? query.catName : 'All'
        this.filterData.sub_industry = query.industryName
          ? query.industryName
          : 'All'
      } else {
        this.filterData.kategori = query.catName ? query.catName : 'Semua'
        this.filterData.sub_industri = query.industryName
          ? query.industryName
          : 'Semua'
      }
      this.showSubFilter = true
    } else {
      this.getDirectories()
    }
    if (this.$route.params.popup) {
      // this.$bvModal.show('infographicPopup')
      this.openPopup(this.$route.params.popup)
    }
  },
  methods: {
    getDirectories: function(
      param = {},
      multiple = false,
      extendedParam = null,
      allValue = false
    ) {
      var params = {}
      // this.directories = []
      if (extendedParam) {
        params = extendedParam
      } else {
        /** define ANY API prequisite */
        params = {
          klaster_slug: 'directories',
          simple: true,
          page: this.page,
          taxonomy_mode: 'strict',
          order: this.order,
          order_by: this.orderBy,
          limit: this.limit,
          lang: this.lang,
        }
        param.page = this.page
      }
      this.isLoading = true
      this.params = params
      /** params need to encoded from object to url params */
      if (param.taxonomy) {
        delete param.page
        this.generatedParams = this.generateParams(
          params,
          param,
          'taxonomy',
          false
        )
        params = this.generatedParams
      } else {
        params = this.generateParams(params, param, 'taxonomy', false)
      }

      /** define endpoint */
      var endpoint = `klaster-by-member-relation?${params}`

      if (allValue === true) {
        this.showSubFilter = false
      }
      // get the news
      Axios.get(endpoint).then((response) => {
        const data = response.data.data
        // console.log(data)
        this.isLoading = false
        // after successfull response, we should then update the menuItems on data() above
        if (response.data) {
          this.directories = data
          this.totalData = response.data.data_total
          // console.log(this.totalData)
          this.totalPages = response.data.page_total
          this.loadOpacity = false
          // console.log(data[0])
          if (this.firstLoad === false) {
            if (this.lang === 'en') {
              if (
                data.length !== 0 &&
                data[0].taksonomi.length !== 0 &&
                data[0].taksonomi.category.data_option.length !== 0
              ) {
                this.filters.categories = data[0].taksonomi.category.data_option
                this.filters.institution_type =
                  data[0].taksonomi.institution_type.data_option
                this.filters.sub_industry =
                  data[0].taksonomi.sub_category.data_option
              } else {
                this.nullData = true
              }
            } else {
              if (data.length !== 0 && data[0].taksonomi.length !== 0) {
                this.filters.categories = data[0].taksonomi.kategori.data_option
                this.filters.institution_type =
                  data[0].taksonomi.jenis_institusi.data_option
                this.filters.sub_industry =
                  data[0].taksonomi.sub_kategori.data_option
              } else {
                this.nullData = true
              }
            }
          }
        }
        this.firstLoad = true
        /** FOR SEO and META tag */
        let keyInfo
        if (response.data.info[this.lang] !== undefined) {
          keyInfo = response.data.info[this.lang]
        } else {
          keyInfo = response.data.info[this.lang + ' ']
        }
        this.pageParentTitle = keyInfo[0].trim()
        this.pageParentDescription = keyInfo[1].trim()
      })
    },
    openPopup: function(slug) {
      this.showModal = true
      this.modalData = []
      this.isModalLoading = true
      this.addHashToLocation('/directories/' + slug)
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'directories',
        simple: true,
        record_slug: slug,
        taxonomy_show: false,
        taxonomy_mode: 'strict',
      }
      /** params need to encoded from object to url params */
      params = this.generateParams(params)
      /** define endpoint */
      var endpoint = `klaster-by-member-relation?${params}`
      // get the news
      Axios.get(endpoint).then((response) => {
        const data = response.data.data[0]
        // after successfull response, we should then update the menuItems on data() above
        if (response.data) {
          this.modalData = data
          this.isModalLoading = false
        }
        /** FOR SEO and META tag */
        if (data.atribut.featured_image.data[0]) {
          this.featuredImage =
            appConfig.s3_endpoint + data.atribut.featured_image.data[0].content
        }
        /** FOR SEO AND META TAG PURPOSE */
        this.pageTitle = data.title
        // console.log(data)
      })
    },
    getDirByCategory: function(cat, catID) {
      this.directories = []
      this.page = 1
      this.totalData = 0
      this.totalPages = 0
      // this.page = 0
      this.resetFilter()
      const params = {
        taxonomy: {},
      }

      // ini salah alias kotor
      // localStorage.setItem('kategori', cat)

      if (cat === 'Institution' || cat === 'Institusi') {
        this.showSubFilter = true
      } else {
        this.showSubFilter = false
      }
      params.catName = cat
      if (this.lang === 'id') {
        this.filterData.kategori = cat
        this.filterValDataID.kategori = catID
        params.taxonomy = {
          kategori: catID,
        }
        this.choosenCategoryParam = catID
        // choosenCategoryParam
        this.getDirectories(params)
      } else {
        this.filterData.category = cat
        this.filterValDataEN.category = catID
        this.choosenCategoryParam = catID
        params.taxonomy = {
          category: catID,
        }
        this.getDirectories(params)
      }
    },
    getDirByInstitution: function(cat, catID) {
      this.directories = []
      this.totalData = 0
      this.totalPages = 0
      // this.page = 0
      const params = {
        taxonomy: {},
      }

      // reset all values
      this.resetFilter()

      if (this.lang === 'id') {
        this.filterData.jenis_institusi = cat
        this.filterValDataID.jenis_institusi = catID
        params.taxonomy = {
          jenis_institusi: catID,
        }
        this.getDirectories(params)
      } else {
        this.filterData.institution_type = cat
        this.filterValDataEN.institution_type = catID
        params.taxonomy = {
          institution_type: catID,
        }
        this.getDirectories(params)
      }
    },
    getAllDirectory: function() {
      const query = this.$route.query
      // console.log(query)
      // this.filters.sub_industry = {}
      this.getDirectories({}, false, null, true)
      this.params = query
      if (this.lang === 'en') {
        this.filterData.category = query.catName ? query.catName : 'All'
        this.filterData.sub_industry = query.industryName
          ? query.industryName
          : 'All'
      } else {
        this.filterData.kategori = query.catName ? query.catName : 'Semua'
        this.filterData.sub_industri = query.industryName
          ? query.industryName
          : 'Semua'
      }
    },
    getDirBySubIndustry: function(cat, catID) {
      this.directories = []
      this.totalData = 0
      this.totalPages = 0
      // this.page = 0
      const params = {
        taxonomy: {},
      }

      // reset all values
      // this.resetFilter()
      // localStorage.setItem('subIndustry', cat)
      params.industryName = cat
      if (cat && catID) {
        if (this.lang === 'id') {
          this.filterData.sub_industri = cat
          this.filterValDataID.sub_industri = catID
          params.taxonomy = {
            kategori: this.choosenCategoryParam,
            sub_industri: catID,
          }
          this.getDirectories(params, true)
        } else {
          this.filterData.sub_industry = cat
          this.filterValDataEN.sub_industry = catID
          params.taxonomy = {
            category: this.choosenCategoryParam,
            sub_industry: catID,
          }
          this.getDirectories(params, true)
        }
      } else {
        if (this.lang === 'id') {
          this.filterData.sub_industri = 'Semua'
        } else {
          this.filterData.sub_industry = 'All'
        }
        this.getDirectories(params)
      }
    },
    resetFilter() {
      this.filterValDataID.kategori = ''
      this.filterValDataEN.category = ''
      this.filterValDataID.jenis_institusi = ''
      this.filterValDataEN.institution_type = ''
      this.filterValDataID.sub_industri = ''
      this.filterValDataEN.sub_industry = ''
      this.filterData.kategori = ''
      this.filterData.category = ''
      this.filterData.kategori = 'Semua'
      this.filterData.category = 'All'
      this.filterData.jenis_institusi = 'Semua'
      this.filterData.institution_type = 'All'
      this.filterData.sub_industri = 'Semua'
      this.filterData.sub_industry = 'All'
    },

    hidePopup() {
      this.showModal = false
    },
    addHashToLocation(params) {
      history.pushState({}, null, params)
      this.currentUrl = window.location.origin + params
    },
    /**
     * Handler paginate
     */
    pageHandler: function(to) {
      this.page = to
      this.scrollToTargetAdjusted('directory-handler')
    },
    /**
     * Ordering Function
     */
    ordering: function(order, orderBy, active = '') {
      // this.News = this.News
      this.activeOrder = active
      this.order = order
      this.orderBy = orderBy
      const params = {
        order: order,
        order_by: orderBy,
        taxonomy: {},
      }
      let filter = ''
      if (this.lang === 'en') {
        filter = this.filterValDataEN
      } else {
        filter = this.filterValDataID
      }
      for (const key in filter) {
        if (filter[key] !== '') {
          params.taxonomy[key] = filter[key]
        }
      }
      this.getDirectories(params)
    },
    /**
     * Check if array is empty
     */
    checkArrayEmpty: function(obj) {
      var array = Object.keys(obj).map((key) => [Number(key), obj[key]])
      if (!array?.length) {
        return false
      } else {
        return true
      }
    },
  },
}
</script>

<template>
  <Layout>
    <Hero
      height="25rem"
      :background="require('@assets/images/demo/directory/Banner_0.jpg')"
    >
      <b-container class="h-100">
        <b-row class="justify-content-center h-100">
          <div class="col-lg-12 text-center align-self-center">
            <h1
              class="text-white"
              :style="{ fontSize: '2.75rem', fontWeight: '700' }"
              >{{ pageParentTitle }}</h1
            >
            <p
              class="mt-3 mb-4"
              :style="{
                color: '#fff',
                fontSize: '1.2rem',
                fontWeight: '300',
              }"
              >{{ pageParentDescription }}</p
            >
          </div>
        </b-row>
      </b-container>
    </Hero>

    <b-container id="directory-handler" class="my-5">
      <b-row v-if="firstLoad === true" class="mt-0 mt-lg-5 justify-content-end">
        <b-col
          v-if="false"
          :cols="'lg-auto col-6'"
          class="text-right mt-0 mt-lg-5"
        >
          <div class="mb-3">
            <span class="mr-3" :style="{ color: 'gray' }">{{
              $t('Institution')
            }}</span>
            <b-dropdown
              :text="
                lang === 'id'
                  ? filterData.jenis_institusi
                  : filterData.institution_type
              "
              dropdown
              variant="light"
              class="mx-0 faqFilter"
            >
              <!-- eslint-disable -->
              <b-dropdown-item
                v-for="(Institution, index) in filters.institution_type"
                :key="index"
                @click="
                  getDirByInstitution(
                    Institution.title,
                    Institution.ktaksonomi_record_id
                  )
                "
                >{{ Institution.title }}</b-dropdown-item
              >
              <!-- eslint-enable -->
            </b-dropdown>
          </div>
        </b-col>
        <b-col
          v-if="filters.categories.length !== 0"
          :cols="'lg-auto col-6'"
          class="text-left mt-0 mt-lg-5"
        >
          <div class="mb-3">
            <span class="mr-3" :style="{ color: 'gray' }">{{
              $t('Categories')
            }}</span>
            <b-dropdown
              :text="lang === 'id' ? filterData.kategori : filterData.category"
              dropdown
              variant="light"
              class="mx-0 faqFilter"
            >
              <!-- eslint-disable -->
              <b-dropdown-item
                v-if="
                  filterData.kategori !== 'Semua' ||
                    filterData.category !== 'All'
                "
                @click="getAllDirectory()"
                >{{ $t('All') }}</b-dropdown-item
              >
              <b-dropdown-item
                v-for="(category, index) in filters.categories"
                :key="index"
                @click="
                  getDirByCategory(
                    category.title,
                    category.ktaksonomi_record_id
                  )
                "
                >{{ category.title }}</b-dropdown-item
              >
              <!-- eslint-enable -->
            </b-dropdown>
          </div>
        </b-col>
        <b-col
          v-if="showSubFilter"
          :cols="'lg-auto col-6'"
          class="text-right mt-0 mt-lg-5"
        >
          <div class="mb-3">
            <span class="mr-3" :style="{ color: 'gray' }">{{
              $t('Sub Category')
            }}</span>
            <b-dropdown
              :text="
                lang === 'id'
                  ? filterData.sub_industri
                  : filterData.sub_industry
              "
              dropdown
              variant="light"
              class="mx-0 faqFilter"
            >
              <!-- eslint-disable -->
              <b-dropdown-item
                v-if="
                  filterData.sub_industri !== 'Semua' ||
                    filterData.sub_industry !== 'All'
                "
                @click="getDirBySubIndustry()"
                >{{ $t('All') }}</b-dropdown-item
              >
              <b-dropdown-item
                v-for="(SubIndustry, index) in filters.sub_industry"
                :key="index"
                @click="
                  getDirBySubIndustry(
                    SubIndustry.title,
                    SubIndustry.ktaksonomi_record_id
                  )
                "
                >{{ SubIndustry.title }}</b-dropdown-item
              >
              <!-- eslint-enable -->
            </b-dropdown>
          </div>
        </b-col>
        <b-col cols="lg-auto col-6" class="text-right mt-0 mt-lg-5">
          <span class="mr-3" :style="{ color: 'gray' }">{{
            $t('Sort by')
          }}</span>
          <b-dropdown
            :text="activeOrder"
            variant="light"
            class="mx-0"
            :class="$style.filter"
          >
            <b-dropdown-item @click="ordering('asc', 'title', 'A - Z')">
              A - Z
            </b-dropdown-item>
            <b-dropdown-item @click="ordering('desc', 'title', 'Z - A')">
              Z - A
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>
      <div
        v-show="isLoading"
        class="position-relative"
        style="min-height: 10rem"
      >
        <img
          src="@assets/icons/loading.gif"
          alt="loading"
          class="loadingIcon"
        />
      </div>
      <b-row>
        <b-col
          v-for="(directory, index) in directories"
          :key="index"
          cols="lg-4"
          class="my-3 d-flex justify-content-scretch"
        >
          <DirectoryCard
            class="w-100"
            :class="isLoading ? 'isLoading' : ''"
            :title="directory.title"
            heading-tag="h5"
            :img-src="
              directory.atribut.length !== 0 &&
              directory.atribut.featured_image.data[0]
                ? directory.atribut.featured_image.data[0].content
                : ''
            "
            :website="
              directory.atribut.length !== 0 &&
              directory.atribut.link_website.data[0]
                ? directory.atribut.link_website.data[0].content
                : ''
            "
            :new-tab="true"
            pointer
            @click.native="openPopup(directory.slug)"
          ></DirectoryCard>
        </b-col>
      </b-row>
      <b-row v-if="totalData > limit" class="mt-4 mb-5 justify-content-center">
        <b-col cols="lg-9">
          <Pagination
            :total-pages="totalPages"
            :selected-page="page"
            :params="generatedParams"
            @clicked="pageHandler"
          ></Pagination>
        </b-col>
      </b-row>
    </b-container>
    <!-- directory POPUP -->
    <b-modal
      id="directoryPopup"
      v-model="showModal"
      size="md"
      :centered="true"
      :hide-header="true"
      :hide-footer="true"
    >
      <b-container>
        <img
          v-show="isModalLoading"
          src="@assets/icons/loading.gif"
          alt="loading"
          class="loadingIcon"
          style="z-index: 1"
        />
        <b-row>
          <!-- close button -->
          <div class="closeIcon">
            <img src="@assets/icons/close.png" alt="x" @click="hidePopup" />
          </div>
          <b-col v-if="modalData.atribut" cols="lg-12" class="directory">
            <div class="w-100 text-center mb-3">
              <img
                v-if="
                  modalData.atribut.length !== 0 &&
                    modalData.atribut.featured_image.data.length !== 0
                "
                v-lazy="modalData.atribut.featured_image.data[0].content"
                alt=""
                class="img-fluid"
                style="width: 10rem"
              />
            </div>
            <div class="directoryHeader">
              <h2>{{ modalData.title }}</h2>
            </div>
            <div v-html-safe="modalData.content" class="directoryBody"> </div>
            <div class="directoryFooter">
              <b-row>
                <b-col
                  v-if="
                    modalData.atribut.length !== 0 &&
                      modalData.atribut.link_website.data.length !== 0
                  "
                  cols="lg-12"
                  class="d-flex align-items-center mt-3 mt-lg-2"
                >
                  <img
                    src="@assets/icons/Icon_D_2.png"
                    alt="icon"
                    width="28px"
                    height="28px"
                    class="mr-2"
                  />
                  <a
                    :href="modalData.atribut.link_website.data[0].content"
                    target="_blank"
                    style="color: #000"
                    >{{ modalData.atribut.link_website.data[0].content }}</a
                  >
                </b-col>
                <b-col
                  v-if="
                    modalData.atribut.length !== 0 &&
                      modalData.atribut.location.data.length !== 0
                  "
                  cols="lg-12"
                  class="d-flex align-items-center mt-3 mt-lg-2"
                >
                  <img
                    src="@assets/icons/Icon_D_1.png"
                    alt="icon"
                    width="28px"
                    height="28px"
                    class="mr-2"
                  />
                  <span
                    :href="modalData.atribut.location.data[0].content"
                    target="_blank"
                  >
                    {{ modalData.atribut.location.data[0].content }}
                  </span>
                </b-col>
                <b-col
                  v-if="
                    modalData.atribut.length !== 0 &&
                      modalData.atribut.email.data.length !== 0
                  "
                  cols="lg-12"
                  class="d-flex align-items-center mt-3 mt-lg-2"
                >
                  <img
                    src="@assets/icons/Icon_Email.png"
                    alt="icon"
                    width="28px"
                    height="28px"
                    class="mr-2"
                  />
                  <span
                    :href="modalData.atribut.email.data[0].content"
                    target="_blank"
                  >
                    {{ modalData.atribut.email.data[0].content }}
                  </span>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.filter {
  ul[role='menu'] {
    &:focus {
      outline: none;
    }
  }
  button {
    background-color: $white;
    border: 1px solid $gray;
    border-radius: 0;
  }
}
</style>

<style lang="scss">
@import '@design';
[class='modal-backdrop'] {
  background-color: rgba(0, 0, 0, 0.2);
}
#directoryPopup {
  [class='modal-header'] {
    border-bottom: none;
  }
  [class='modal-body'] {
    min-height: 50vh;
    padding: 2rem;
  }
  [class='modal-content'] {
    border: none;
    border-radius: $radius;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.15);
  }
  .closeIcon {
    z-index: 1;

    img {
      position: absolute;
      top: 2.5rem;
      right: 2.5rem;
      width: 24px;
      cursor: pointer;
    }
  }
  .directory {
    font-family: $content-font-family;
    .directoryHeader {
      h2 {
        color: $primary;
      }
    }
    .directoryBody {
      margin: 2rem 0;
      color: gray;
    }
    .directoryFooter {
      display: flex;
      align-items: center;
      .social {
        width: 40px;
        margin-right: 0.5rem;
        cursor: pointer;
        &:first-child {
          margin-left: 0.75rem;
        }
      }
    }
  }
}
@media only screen and (max-width: 600px) {
  #directoryPopup {
    padding: 0;
    [class~='modal-dialog'] {
      margin: 0;
    }
    [class~='modal-content'] {
      border-radius: 0;
    }
    [class='modal-body'] {
      padding: 1rem;
    }
    .closeIcon {
      img {
        position: absolute;
        top: 1rem;
        right: 1rem;
        width: 32px;
        padding: 0.5rem;
        background-color: #fff;
        border: 1px solid black;
        border-radius: 50%;
      }
    }
    .directory {
      .directoryHeader {
        margin: 1rem 0;
      }
      .directoryFooter {
        flex-wrap: wrap;
        button {
          width: 100%;
        }
        [class~='social-wrapper'] {
          margin: 1rem 0;
        }
      }
    }
  }
}
</style>
